import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserGraduate, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Header from "../components/Header";
import { Container } from "react-bootstrap";
// import axios from 'axios';
import { Modal, } from 'react-bootstrap'; // For Bootstrap Modal
import { Table, Grid, Paper, Typography, Tabs, Tab, Button, Badge, Box } from '@mui/material';
import { TableContainer, TableHead, TableRow, TableCell, TableBody, TextField, InputAdornment } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download'; // For the download icon
import { removeBracketedText } from '../Axiosinstance';
import { faMapMarkerAlt, faPhone } from '@fortawesome/free-solid-svg-icons';
import axios from '../Axiosinstance'; // Make sure to import axios properly
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import Loader from '../Loader';

import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const AluminiDetails = () => {

    const [paidAlumni, setPaidAlumni] = useState([]);
    const [unpaidAlumni, setUnpaidAlumni] = useState([]);
    const [selectedTab, setSelectedTab] = useState(0); // 'paid' or 'unpaid'
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [studentInfo, setStudentInfo] = useState();
    const [data1, setData1] = useState('');

    const [showModal, setShowModal] = useState(false);
    const [scheduleDate, setScheduleDate] = useState(null);
    const [courseFee, setCourseFee] = useState([]);
    const [registrationFee, setRegistrationFee] = useState([]);
    const [paidAlumniCount, setPaidAlumniCount] = useState(0);
    const [unpaidAlumniCount, setUnpaidAlumniCount] = useState(0);
    const [searchPaid, setSearchPaid] = useState(""); // Search for Paid
    const [searchUnpaid, setSearchUnpaid] = useState("");
    const [search, setSearch] = useState("");
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));


    // Fetch alumni data from API




    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };


    const exportToExcel = (data, fileName) => {
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Define column widths
        worksheet["!cols"] = [
            { wch: 35 }, // Name column width
            { wch: 34 },
            { wch: 10 },// NRIC column width
            { wch: 35 }, // Email column width
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        XLSX.writeFile(workbook, `${fileName}.xlsx`);
    };


    useEffect(() => {
        const fetchAlumni = async () => {
            try {
                const response = await axios.get("/registrationadvances/getAllAlumni");
                const data = response.data;
                console.log("department:", data)
                // Assuming the API only returns paid alumni
                setPaidAlumni(data);
            } catch (err) {
                // Handle error response
                setError(err.response?.data?.message || err.message);
            } finally {
                setLoading(false);
            }
        };


        fetchAlumni();
    }, []);


    useEffect(() => {
        const fetchAlumni1 = async () => {
            try {
                const response = await axios.get("/registrationadvances/AlumniStudentDetailss");
                const data = response.data;
                console.log(response.data, "unpaid")
                // Assuming the API only returns paid alumni
                setUnpaidAlumni(data);
            } catch (err) {
                // Handle error response
                setError(err.response?.data?.message || err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchAlumni1();
    }, []);



    useEffect(() => {
        const fetchAlumniCounts = async () => {
            try {
                // Fetch Paid Alumni Count
                const paidResponse = await axios.get("registrationadvances/registration-advance-count");
                setPaidAlumniCount(paidResponse.data || 0); // Set only the numeric count

                // Fetch Unpaid Alumni Count
                const unpaidResponse = await axios.get("registrationadvances/alumni-count");
                setUnpaidAlumniCount(unpaidResponse.data || 0); // Set only the numeric count
            } catch (err) {
                setError(err.response?.data?.message || err.message);
            }
        };

        fetchAlumniCounts();
    }, []);

    const handleshowStudent = async (student, title) => {
        console.log(student, title, "id");
        try {
            // First API call
            //   co nst response1 = await axios.get(`registrationadvances/getAllAlumni/${student.registrationAdvanceid}`);
            let response1;
            if (title === "Paid Alumni") {
                response1 = await axios.get(`registrationadvances/getAllAlumni/${student.registrationAdvanceid}`);
                console.log("Full response data:", response1.data); // Log the entire response data
            }
            else if (title === "Unpaid Alumni") {
                response1 = await axios.get(`/registrationadvances/${student.id}`);
                console.log("Full response data:", response1.data); // Log the entire response data
            }
            console.log("show the data:", response1.data)
            setStudentInfo(response1.data);

            // Check if courseFeeDetails exists
            const { courseFeeDetails, batch, scheduleDate
            } = response1.data;
            if (courseFeeDetails) {
                console.log("courseFeeDetails:", courseFeeDetails);  // Log the courseFeeDetails
                setData1(courseFeeDetails);
                // Separate CourseFee and RegistrationFee
                const courseFees = courseFeeDetails.filter(fee => fee.type === "CourseFee");
                const registrationFees = courseFeeDetails.filter(fee => fee.type === "RegistrationFee");
                console.log("courseFees", courseFees);
                console.log("registrationFees", registrationFees);
                setCourseFee(courseFees);
                setRegistrationFee(registrationFees);
                console.log("data being set:", data1);
            } else {
                console.log("courseFeeDetails not found in response1.data");
            }

            if (scheduleDate) {
                console.log("setScheduleDate:", scheduleDate);  // Log the courseFeeDetails

                // Create a map for moduleDetails based on id
                const moduleDetailsMap = {};
                batch?.moduleDetails.forEach(module => {
                    moduleDetailsMap[module.id] = module.moduleName;
                });

                // Map the module details to the schedule data based on startModulus
                const updatedScheduleData = scheduleDate.map(schedule => {
                    // Log the current schedule's startModulus
                    console.log('schedule.startModulus:', schedule.startModulus);

                    // Get the module based on the startModulus index
                    const moduleDetail = batch?.moduleDetails[schedule.startModulus - 1];

                    // Log the found moduleDetail
                    console.log('Found moduleDetail:', moduleDetail);

                    return {
                        ...schedule,
                        moduleDetail: moduleDetail ? moduleDetail.moduleName : 'N/A'  // Assign moduleName or 'N/A' if no module is found
                    };
                });
                setScheduleDate(updatedScheduleData);
                console.log("data being set:", updatedScheduleData);
            } else {
                console.log("setScheduleDate not found in response1.data");
            }


            setShowModal(true);
        } catch (error) {
            console.error('Error fetching student details:', error);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setStudentInfo(null);
    };
    if (loading) {
        return (
            <div className="text-center mt-4">
                <Loader />
            </div>
        );
    }

    if (error) {
        return <p className="text-center text-danger mt-4">Error: {error}</p>;
    }

    const filteredPaidAlumni = paidAlumni.filter(alumni =>
        alumni.name.toLowerCase().includes(searchPaid.toLowerCase())
    );

    const filteredUnpaidAlumni = unpaidAlumni.filter(alumni =>
        alumni.name.toLowerCase().includes(searchUnpaid.toLowerCase())
    );


    const renderTable = (data, title) => {
        console.log("data:", data)
        const filteredData = data.filter(alumni =>
            alumni.name.toLowerCase().includes(search.toLowerCase())
        );






        return (
            <div style={{ width: "80%", padding: "20px", marginTop: "2%", margin: "33px auto" }}>
                {/* Fixed Box for any fixed elements */}
                <Box
                    sx={{
                        position: 'fixed',
                        top: '100px',
                        left: '20px',
                        zIndex: 1000,
                    }}
                >
                    {/* Any fixed content goes here */}
                </Box>

                {/* Search and Excel Buttons */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                    <TextField
                        label="Search Name"
                        variant="outlined"
                        size="small"
                        value={selectedTab === 0 ? searchPaid : searchUnpaid}
                        onChange={(e) => {
                            if (selectedTab === 0) {
                                setSearchPaid(e.target.value);
                            } else {
                                setSearchUnpaid(e.target.value);
                            }
                        }}
                        style={{ maxWidth: "350px", flex: 1 }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />

                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<DownloadIcon />}
                        onClick={() => {
                            const filename = selectedTab === 0 ? "Paid_Alumni" : "Unpaid_Alumni";
                            exportToExcel(
                                filteredData.map(({ name, nric, email, batchName }) => ({
                                    NAME: name.toUpperCase(),
                                    COURSE: batchName,
                                    NRIC: nric || '-',
                                    EMAIL: email.toUpperCase(),
                                })),
                                filename
                            );
                        }}
                        style={{ marginLeft: "20px" }}
                    >
                        Download Excel
                    </Button>
                </div>

                {/* Table Rendering */}
                <Paper elevation={3} style={{ padding: "10px" }}>
                    <div style={{ overflowX: "auto", maxHeight: "400px" }}>
                        <Table aria-label="sticky table">
                            <TableHead style={{ position: "sticky", top: 0, backgroundColor: "#f4f4f4", zIndex: 1 }}>
                                <TableRow>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>S.NO</TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>NAME</TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>COURSE</TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>NRIC</TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>EMAIL</TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>VIEW</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredData.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={6} align="center">
                                            <Typography variant="h6" color="textSecondary">No data present</Typography>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    filteredData.map((alumni, index) => (
                                        <TableRow key={alumni.registrationAdvanceid} hover>
                                            <TableCell align="center">{index + 1}</TableCell>
                                            <TableCell align="center">{alumni?.name ? alumni.name.toUpperCase() : "No Name"}</TableCell>
                                            <TableCell align="center">{alumni?.batchName || "No Course"}</TableCell>
                                            <TableCell align="center">{alumni?.nric ? alumni.nric : '-'}</TableCell>
                                            <TableCell align="center">{alumni?.email || "No Email"}</TableCell>
                                            <TableCell align="center">
                                                <Button
                                                    variant="outlined"
                                                    onClick={() => handleshowStudent(alumni, title)}
                                                    color="primary"
                                                >
                                                    VIEW DETAILS
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </div>
                </Paper>

            </div>
        );
    };



    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };





    return (
        <>
            <Header />

            {/* Tab Buttons */}
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: isMobile ? '-10px' : '-40px' }}>
                <div style={{ width: '50%', display: 'flex', justifyContent: 'center' }}>
                    <Tabs
                        value={selectedTab}
                        onChange={handleChange}
                        aria-label="Alumni Tabs"
                        variant="fullWidth"
                        sx={{
                            borderRadius: 10,
                            width: '100%', // Ensures full width of the container
                            "@media (max-width: 600px)": { // Responsive design for small screens
                                variant: "standard", // Change to standard on small screens
                                width: 'auto', // Auto width for smaller screens
                            },
                            display: 'flex',
                            justifyContent: 'center',
                            "& button": {
                                borderRadius: 10,
                                color: "#555",
                                margin: 'auto',
                                display: 'block',
                            },
                            "& button:hover": {
                                backgroundColor: "#eee",
                            },
                            "& button:active": {
                                backgroundColor: "#ddd",
                            },
                            "& button.Mui-selected": {
                                backgroundColor: "#007bff",
                                color: "#fff",
                            },
                            "& .MuiTabs-indicator": {
                                display: 'none', // Remove the underline
                            },
                        }}
                    >
                        {/* <Tab label="Paid Alumni" />
                        <Tab label="Unpaid Alumni" value="1" /> */}
                        <Tab
                            label={
                                <Badge badgeContent={paidAlumniCount} color="primary">
                                    Paid Alumni
                                </Badge>
                            }

                        />
                        <Tab
                            label={
                                <Badge badgeContent={unpaidAlumniCount} color="secondary">
                                    Unpaid Alumni
                                </Badge>
                            }
                            value='1'
                        />
                        {/* <div style={{ fontSize: "24px", fontWeight: "600", color: "#555" }}>{unpaidAlumniCount} </div> */}
                        {/* <div style={{ fontSize: "24px", fontWeight: "600", color: "#555" }}>{paidAlumniCount} </div> */}
                    </Tabs>
                </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>

                {selectedTab === 0 && renderTable(filteredPaidAlumni, "Paid Alumni")}
                {selectedTab === "1" && renderTable(filteredUnpaidAlumni, "Unpaid Alumni")}
            </div>

            {/* view Details Table */}
            <div> <Modal
                show={showModal}
                onHide={handleCloseModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                fullscreen
            >
                <Modal.Header closeButton>
                    <Modal.Title>Student Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {studentInfo && (
                        <Paper style={{ padding: 20, border: '1px solid #ccc' }}>
                            <Grid container spacing={3}>
                                {/* Personal Details */}
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>NAME:</strong> {studentInfo.name.toUpperCase() || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>PHONE NO:</strong> {studentInfo.handPhone || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>DATE OF BIRTH:</strong> {studentInfo.dob || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>GENDER:</strong> {studentInfo.gender.toUpperCase() || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>PASSPORT NO:</strong> {studentInfo.passportNo.toUpperCase() || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>EMAIL:</strong> {studentInfo.email.toUpperCase() || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>TYPE:</strong> {studentInfo?.type.toUpperCase() || '-'}</Typography>
                                </Grid>
                                {/* <Grid item xs={12} sm={6}>
                <Typography variant="body1"><strong>Course:</strong> {removeBracketedText(studentInfo?.batch.course) || '-'}</Typography>
              </Grid> */}
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1">
                                        <strong>COURSE:</strong> {removeBracketedText(studentInfo?.batch?.course.toUpperCase() || '-')}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>COUNTRY OF BIRTH:</strong> {studentInfo?.countryBirth.toUpperCase() || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>NATIONALITY:</strong> {studentInfo?.nationality.toUpperCase() || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1">
                                        <strong>KNOW ABOUT PROGRAM:</strong> {studentInfo?.knowAboutProgram || '-'}
                                        {(studentInfo?.knowAboutProgram === 'referral' || studentInfo?.knowAboutProgram === 'other') && (
                                            <>
                                                {' - '}
                                                {studentInfo?.knowAboutProgram === 'referral'
                                                    ? studentInfo?.referalfriend || '-'
                                                    : studentInfo?.otherDetails || '-'}
                                            </>
                                        )}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>DATE:</strong> {formatDate(studentInfo?.date) || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>COMPANY:</strong> {studentInfo?.company.toUpperCase() || '-'}</Typography>
                                </Grid>
                                {/* <Grid item xs={12} sm={6}>
                <Typography variant="body1"><strong>{studentInfo?.proofType === 'NRIC' ? 'NRIC :' : 'FIN :'}</strong> {studentInfo.nric || '-'}</Typography>
              </Grid> */}
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1">
                                        <strong>{studentInfo?.proofType === 'NRIC' ? 'NRIC :' : 'FIN :'}</strong>
                                        {studentInfo?.nric}
                                    </Typography>
                                </Grid>


                                {/* Address Details */}
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} /> <strong>ADDRESS (OFFICE):</strong> {studentInfo?.addressOffice.toUpperCase() || '-'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} /> <strong>ADDRESS (HOME):</strong> {studentInfo?.addressHome.toUpperCase() || '-'}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1">
                                        <FontAwesomeIcon icon={faPhone} /> <strong>PHONE (OFFICE): </strong>{studentInfo?.phoneOffice || '-'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1">
                                        <FontAwesomeIcon icon={faPhone} /> <strong>PHONE (HOME): </strong>{studentInfo?.phoneHome || '-'}
                                    </Typography>
                                </Grid>

                                {/* Emergency Contact */}
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1">
                                        <FontAwesomeIcon icon={faPhone} /> <strong>EMERGENCY CONTACT:</strong>{studentInfo?.emergencyPhone || '-'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>CONTACT NAME:</strong> {studentInfo?.emergencyName.toUpperCase() || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>RELATION:</strong> {studentInfo?.emergencyRelation.toUpperCase() || '-'}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Typography variant="body1"><strong>PHONE:</strong> {studentInfo?.emergencyPhone || '-'}</Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    )}
                    <>
                        {/* Schedule Date Details */}
                        <Typography variant="h6" gutterBottom style={{ fontWeight: "bolder" }}>
                            SCHEDULE DATES
                        </Typography>
                        <TableContainer component={Paper} sx={{ maxWidth: "100%", overflowX: "auto" }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell><strong>Start Modulus</strong></TableCell>
                                        <TableCell><strong>Start Date</strong></TableCell>
                                        <TableCell><strong>End Date</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {scheduleDate?.length > 0 ? (
                                        scheduleDate.map((schedule, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{schedule.moduleDetail}</TableCell>
                                                <TableCell>{schedule.startDate ? formatDate(schedule.startDate) : "N/A"}</TableCell>
                                                <TableCell>{schedule.endDate ? formatDate(schedule.endDate) : "N/A"}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={3} align="center">
                                                No schedule dates available.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>



                        {/* Registration Fee Details */}
                        <Typography variant="h6" gutterBottom style={{ fontWeight: "bolder" }}>
                            REGISTRATION FEE DETAILS
                        </Typography>
                        <TableContainer component={Paper} sx={{ maxWidth: "100%", overflowX: "auto" }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell><strong>Session Date</strong></TableCell>
                                        <TableCell><strong>Amount</strong></TableCell>
                                        <TableCell><strong>Course Fee Remaining</strong></TableCell>
                                        <TableCell><strong>Discount Amount</strong></TableCell>
                                        <TableCell><strong>Status</strong></TableCell>
                                        <TableCell><strong>Installment Counts</strong></TableCell>
                                        <TableCell><strong>Fees Type </strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {registrationFee.length > 0 ? (
                                        registrationFee.map((feeDetail, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{feeDetail.sessionDate ? formatDate(feeDetail.sessionDate) : "N/A"}</TableCell>
                                                <TableCell>{feeDetail.amount || "N/A"}</TableCell>
                                                <TableCell>{feeDetail.courseFeeRemaining}</TableCell>
                                                <TableCell>{feeDetail.discountAmount}</TableCell>
                                                <TableCell>{feeDetail.status.toUpperCase() || "-"}</TableCell>
                                                <TableCell>{feeDetail.installmentCounts?.length ? feeDetail.installmentCounts.join(", ") : "-"}</TableCell>
                                                <TableCell>{feeDetail.type.toUpperCase() || "-"}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={7} align="center">
                                                No course fee details available.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>


                        {/* Course Fee Details */}
                        <Typography variant="h6" gutterBottom style={{ fontWeight: "bolder" }}>
                            COURSE FEE DETAILS
                        </Typography>
                        <TableContainer component={Paper} sx={{ maxWidth: "100%", overflowX: "auto" }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                    <TableCell><strong>Session Date</strong></TableCell>
                                        <TableCell><strong>Amount</strong></TableCell>
                                        <TableCell><strong>Course Fee Remaining</strong></TableCell>
                                        <TableCell><strong>Discount Amount</strong></TableCell>
                                        <TableCell><strong>Status</strong></TableCell>
                                        <TableCell><strong>Installment Counts</strong></TableCell>
                                        <TableCell><strong>Fees Type </strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {courseFee.length > 0 ? (
                                        courseFee.map((feeDetail, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{feeDetail.sessionDate ? formatDate(feeDetail.sessionDate) : "N/A"}</TableCell>
                                                <TableCell>{feeDetail.amount || "N/A"}</TableCell>
                                                <TableCell>{feeDetail.courseFeeRemaining}</TableCell>
                                                <TableCell>{feeDetail.discountAmount}</TableCell>
                                                <TableCell>{feeDetail.status.toUpperCase() || "-"}</TableCell>
                                                <TableCell>{feeDetail.installmentCounts?.length ? feeDetail.installmentCounts.join(", ") : "-"}</TableCell>
                                                <TableCell>{feeDetail.type.toUpperCase() || "-"}</TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={7} align="center">
                                                No course fee details available.
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>

                </Modal.Body>
            </Modal>
            </div>


        </>

    );
};

export default AluminiDetails;

